import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-five-pipe',
  templateUrl: './five-pipe.component.html',
  styleUrls: ['./five-pipe.component.scss']
})
export class FivePipeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
